import { SvgIcon, SvgIconProps } from '@mui/material';

export default function GoogleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.29 1.22 8.18 2.25l6.07-6.07C34.92 2.92 30.14 1 24 1 14.8 1 7.02 6.48 3.82 14.02l7.43 5.76C13.08 14.02 18.08 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.5 24c0-1.63-.15-3.2-.42-4.71H24v9.42h12.7c-.55 2.95-2.18 5.44-4.61 7.12l7.43 5.76C43.98 37.52 46.5 31.14 46.5 24z"/>
      <path fill="#FBBC05" d="M10.25 28.24c-1.02-2.95-1.02-6.18 0-9.12L2.82 13.36C.98 16.52 0 20.14 0 24s.98 7.48 2.82 10.64l7.43-5.76z"/>
      <path fill="#34A853" d="M24 46.5c6.14 0 11.3-2.02 15.07-5.48l-7.43-5.76c-2.02 1.35-4.55 2.16-7.64 2.16-5.92 0-10.92-4.52-12.75-10.64l-7.43 5.76C7.02 41.52 14.8 46.5 24 46.5z"/>
    </SvgIcon>
  );
}
